import dayjs from "dayjs";

import { Data } from "./types";

import { IInstitution } from "@/api/types/institution";

export function createData(data: IInstitution): Data {
    const { id, name, email, maxConcurrentDevices, status, startDate, endDate, createdAt, updatedAt } = data;

    return {
        id,
        name: name || "-",
        email: email || "-",
        maxConcurrentDevices,
        status,
        startDate: dayjs(startDate).format("YYYY-MM-DD"),
        endDate: dayjs(endDate).format("YYYY-MM-DD"),
        createdAt: dayjs(createdAt).format("YYYY-MM-DD HH:mm"),
        updatedAt: dayjs(updatedAt).format("YYYY-MM-DD HH:mm"),
    };
}
